import { Component, OnInit, ViewChild } from '@angular/core';
import { PolicyService } from 'src/app/_services/policy.service';
import { MatColumnDef, MatTableDataSource } from '@angular/material/table';
import { CdkColumnDef } from '@angular/cdk/table';
import { MatTableModule } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { IPolicy } from 'src/app/_models/compliance';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { AppConfig } from 'src/assets/config/config/app-config';

@Component({
  selector: 'app-records-management',
  templateUrl: './records-management.component.html',
  styleUrls: ['./records-management.component.scss']
})

export class RecordsManagementComponent implements OnInit {

  isPolicy: boolean = false;
  isHoldGroup: boolean = false;
  isDisposition: boolean = false;
  isRetentionGroup: boolean = false;
  aclGroup: any =  this.config.getACLGroup().settings.recordMgmt;

  constructor(private config: AppConfig) { }

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  ngOnInit(): void {
    this.policy()
  }

  policy() {
    this.isPolicy = true;
    this.isRetentionGroup = false;
    this.isDisposition = false;
    this.isHoldGroup = false;
  }


  retentionGroup() {
    this.isRetentionGroup = true;
    this.isPolicy = false;
    this.isDisposition = false;
    this.isHoldGroup = false;
  }

  holdGroup() {
    this.isRetentionGroup = false;
    this.isPolicy = false;
    this.isDisposition = false;
    this.isHoldGroup = true;
  }

  disposition() {
    this.isRetentionGroup = false;
    this.isPolicy = false;
    this.isDisposition = true;
    this.isHoldGroup = false;
  }

}